import React from 'react';
import { Alert, Modal, Typography } from 'antd';

const { Paragraph } = Typography;

export type CompositionInitializeConfirmModalProps = {
  open: boolean;
  loading?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

/**
 * Confirmation before applying recommended composition (FE-005A-7).
 */
const CompositionInitializeConfirmModal: React.FC<CompositionInitializeConfirmModalProps> = ({
  open,
  loading = false,
  onConfirm,
  onCancel,
}) => (
  <Modal
    title="Применить рекомендуемый состав"
    open={open}
    onOk={onConfirm}
    onCancel={onCancel}
    confirmLoading={loading}
    okText="Применить"
    cancelText="Отмена"
    destroyOnClose
  >
    <Alert
      type="info"
      showIcon
      message="Повторное применение состава"
      description="Рекомендуемый состав будет создан или обновлён повторно в соответствии с текущей бизнес-логикой Backend (Builder). Существующие позиции могут быть пересобраны."
      style={{ marginBottom: 12 }}
    />
    <Paragraph style={{ marginBottom: 0 }}>
      Применить рекомендуемый состав комплекта для редактирования?
    </Paragraph>
  </Modal>
);

export default CompositionInitializeConfirmModal;
